import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

interface RewardLoadingProps {
  messageKey: string;
}

const RewardLoading = ({ messageKey }: RewardLoadingProps) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        height: '340px',
      }}
    >
      <Spin size="large" />
      <div
        style={{
          fontSize: '14px',
          color: '#888',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        <div>{t(messageKey)}</div>
        <div>{t('pleaseWait')}</div>
      </div>
    </div>
  );
};

export default RewardLoading;
